/** EXAMPLE

{
    "m": "1",   // multiplier to be applied. When apply should reset reel multiplier to 1
    "p": "21",  // the symbol index in the grid mask "0000011100000000000000000"
    "h": "0000010000010000000000001",
    "reelMultiplier": [ "3", "1", "1", "3", "3" ]
}

 */
import { maskToMatrixPositions } from "@aceroll/platform-hacksaw";
import maskIndexToPosition from "../mask-index-to-position";
export default function (data) {
    const REELS = 5;
    const parsed = {
        multiplier: parseInt(data.m),
        position: maskIndexToPosition(data.p, REELS),
        reelMultipliers: data.reelMultiplier.map((item) => { return parseInt(item); }),
        positions: maskToMatrixPositions(data.h, REELS)
    };
    return parsed;
}